<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title15"></a>
<div class="p-c"><span>For Stacey, of course</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466826052_ded01.vue?69ba0aa8